import React from 'react'
import styled from 'styled-components'
import { Flex, Text, Box } from 'pcln-design-system'
import PropTypes from 'prop-types'

const getPriceStyleProps = ({ color }) => ({
  lineHeight: 1,
  fontSize: 1,
  bold: true,
  color: color,
})

const StyledText = styled(Text)`
  white-space: nowrap;
`

const ExpressDealPrice = ({ price, isRoundTrip, color, pricingDisclosure, ...props }) => {
  const style = getPriceStyleProps({ color })
  return (
    <Box {...props}>
      <Flex justifyContent={['flex-end', 'center']} alignItems='flex-start' pb={1}>
        {!!price.incrementalSign && (
          <Text {...style} fontSize={4} mr={1}>
            {price.incrementalSign}
          </Text>
        )}
        <Text {...style}>$</Text>
        <Text {...style} fontSize={['20px', '24px']}>
          {Math.ceil(price.total)}
        </Text>
      </Flex>
      {pricingDisclosure && (
        <Text fontSize={0} color='text.light'>
          {pricingDisclosure}
        </Text>
      )}
      <StyledText fontSize={0} color='text.light'>
        {isRoundTrip && !pricingDisclosure ? 'round-trip' : 'per person'}
      </StyledText>
    </Box>
  )
}

ExpressDealPrice.defaultProps = {
  color: 'primary.base',
}

ExpressDealPrice.propTypes = {
  isRoundTrip: PropTypes.bool,
  color: PropTypes.string,
  pricingDisclosure: PropTypes.string,
  price: PropTypes.shape({
    dollars: PropTypes.string,
    cents: PropTypes.string,
    total: PropTypes.number,
    incrementalSign: PropTypes.string,
  }),
}

export { ExpressDealPrice }
